var MDB = window.MDB || {};
MDB.DPN = MDB.DPN || {};
MDB.DPN.Offers = MDB.DPN.Offers || {};
MDB.DPN.Offers.Requests = MDB.DPN.Offers.Requests || {};

(function ($) {
    var form = $('.save-request-form')
        , crudServiceBaseUrl = '/api/DPN/Offers'
        , dropdownConfigs = form.data('dropdown-config')
        , multiDropdownFields = ['TitleIds', 'ChannelIds'];

    function dropdownEditor(container, opts, callback, configName) {
        configName = configName || opts.field;
        var config = dropdownConfigs[configName];
        
        callback = callback || $.noop;

        //Due to Kendo's handling of null values, we have to set the field manually
        config.change = function (e) {
            opts.model[opts.field] = e.sender.value();
            callback(opts.model, _.find(config.dataSource.data, { Value: opts.model[opts.field] }));
            opts.model.dirty = true;
        };

        var type = multiDropdownFields.indexOf(opts.field) !== -1 ? 'kendoMultiSelect' : 'kendoDropDownList';
        return MDB.KendoConfigBuilder.gridDropdownEditor(container,  opts.field, undefined,  config, opts, type);
    }
    
    function customDropdownEditor(container, opts) {
        var config = dropdownConfigs[opts.field];
        var isCustom = !_.find(config.dataSource.data, {Value: opts.model[opts.field]});
        
        var isCustomCheckbox = $('<input />', {
            type: 'checkbox',
            title: 'Vrije invoer',
            checked: isCustom,
            css: { 'margin-right': '5px' }
        });
        
        var customInput = $('<input />', {
            class: 'k-input k-textbox hidden custom-input',
            value: opts.model[opts.field],
            css: { 'width': '80%' }
        });

        container.append(isCustomCheckbox);
        container.append(customInput);

        var dropdownInput = dropdownEditor(container, opts, function (model) {
            customInput.val(model[opts.field]);
        });
        
        dropdownInput = $(dropdownInput.data('kendoDropDownList').wrapper);
        dropdownInput.width('80%');
        dropdownInput.addClass('custom-input');
        
        customInput.on('change', function () {
            opts.model[opts.field] = this.value;
            opts.model.dirty = true;
        });
        
        isCustomCheckbox.on('change', function () {
            var hiddenInput = this.checked ? dropdownInput : customInput;
            var displayedInput = this.checked ? customInput : dropdownInput;
            
            hiddenInput.addClass('hidden');
            displayedInput.removeClass('hidden');
        });

        isCustomCheckbox.trigger('change');
    }

    function multiSelectEditor(container, opts){
        var config = dropdownConfigs[opts.field];
        config.autoClose = false;

        dropdownEditor(container, opts);
        
        // MDB.KendoConfigBuilder.gridDropdownEditor(container,  opts.field, undefined,  config, opts, 'kendoMultiSelect');
    }

    function shapeData(opts, model){
        multiDropdownFields.forEach(function (field) {
            //Newly added values are formatted as .NET SelectListItem entities
            var items = _.filter(opts.data[field], _.isString)
                , newValues = _.filter(opts.data[field], _.isObject);

            opts.data[field] = _.concat(items,  _.map(newValues, 'Value'));
        });

        opts.data.RequestId = model.Id;

        return opts;
    }
    
    function dropdownDisplayValue(model, field, configName){
        configName = configName || field;
        var config = dropdownConfigs[configName];
        
        var selectedValues = [];
        var fieldValue = model[field];
        
        if (!fieldValue) {
            return '';
        }

        if (multiDropdownFields.indexOf(field) !== -1){
            selectedValues = _.filter(config.dataSource.data, function(item){
                return fieldValue.indexOf(item.Value) !== -1; 
            });
        } else{
            selectedValues = _.filter(config.dataSource.data, {Value: fieldValue.toString()});
        }
        
        return _.map(selectedValues, 'Text').join(', ');
    }
    
    function syncAndReloadGrid(grid) {
        grid = $(grid);
        var kGrid = grid.data('kendoGrid');
        
        var ds = kGrid.dataSource;
        
        ds.sync().then(function () {
            ds.read()
                .then(function () {
                    kGrid.refresh(); 
                });
        });
    }
    
    $.extend(MDB.DPN.Offers.Requests, {
        boot: function (model) {
            //Blank row to allow nulls
            //dropdownConfigs['PremiumId'].optionLabel = 'Geen premium';
            var grids = [];

            var cloneTitleIdsForType = function(type, map){
                var clone = _.cloneDeep(dropdownConfigs['TitleIds']);
                var titlesOfType = MDB.DPN.Offers.getTitles(type);
                
                clone.dataSource.data = _.map(_.filter(clone.dataSource.data, function(item){
                    return titlesOfType.indexOf(item.Text) !== -1 
                }), map);
                
                return clone;
            };
            
            dropdownConfigs['TitleIds-bab'] = cloneTitleIdsForType('bab', function (o) {
                return o 
            });
            dropdownConfigs['TitleIds-ban'] = cloneTitleIdsForType('ban', function(o) {
                return o 
            });
            dropdownConfigs['ProductNames-p5'] = cloneTitleIdsForType('p5', function(o) {
                return { Text: o.Text, Value: o.Text }
            });
            
            form.find('.kendo-dropdown').kendoDropDownList({
                filter: 'contains'
            });

            var datePicker = form.find('[name$="DeadlineValue"]');
            
            datePicker.kendoDatePicker({
                dateInput: true,
                format: 'dd-MM-yyyy',
                min: new Date()
            });
            
            var kLabelSelector = MDB.KendoConfigBuilder.extendablebleMultiDropdown(form.find('[name$="Labels"]'));
            kLabelSelector.value(model.Labels);
            kLabelSelector.enable(model.EnableRequestEditing);
            $(kLabelSelector.wrapper).removeClass('hidden');
            
            MDB.DPN.Offers.Requests.bindToggleableSelections(form);
            
            if (model.IsNewSite){
                form.find('[name$="IsNewSite"]').trigger('change');
            }

            $('.action-handler').on('click', function () {
                var $this = $(this);
                
                var action = $this.data('action');
                var shouldSave = action === 'save';

                grids.forEach(function (grid) {
                    $(grid).data('kendoGrid').dataSource.sync();
                });
                
                if (action === 'publish'){
                    shouldSave = true;
                    
                    var allRowsApproved = MDB.trueForAll(function () {
                        return _.map(['.ban-rows-grid', '.p5-rows-grid'], function (selector) {
                            var grid = $(selector).data('kendoGrid');
                            
                            //Ensure all rows are approved or declined
                            return MDB.trueForAll(_.map(grid.dataSource.data(), function(obj){
                                return obj.Status !== 0
                            }));
                        });
                    });
                    
                    if (!allRowsApproved) {
                        MDB.alert(MDB.loadResourceString('OfferRequest_NotAllRowsApproved_Message'));
                        return;
                    }
                }
                
                if (action === 'create-site'){
                    shouldSave = true;
                    form.find('[name$="CreateSite"]').val(true);
                }
                
                if (action === 'submit'){
                    shouldSave = true;
                    
                    $.ajax({
                        url: '/api/DPN/Offers/DuplicateRequestRowGroups?requestId=' + model.Id,
                        success: function(data){
                            if (data && data.length && !MDB.DPN.Offers.Requests.allowDuplicates){
                                var grid = $('.concept-rows-grid').data('kendoGrid');
                                var ds = grid.dataSource;

                                data.forEach(function (id) {
                                    //Colour is automatically removed when the row is edited
                                    $('[data-uid="' + ds.get(id).uid + '"]').css({'background-color': '#dd4b39'})
                                });

                                MDB.DPN.Offers.Requests.allowDuplicates = true;
                            } else{
                                MDB.DPN.Offers.Requests.submitRequestForm(form, $this);
                            }
                        }
                    });
                    
                    return;
                }
                
                if (action === 'decline'){
                    shouldSave = true;

                    var declineReason = form.find('[name$="DeclineReason"]');
                    if (!declineReason.val()){
                        var clone = declineReason.clone();
                        
                        var declinePopup = MDB.modal({
                            buttons: [
                                '<button type="button" class="btn btn-primary btn-ok">Ok</button>'
                            ],
                            shapeHtml: function(html){
                                html = $(html);

                                var body = html.find('.modal-body');
                                body.append('<h3>Vul een afkeur reden in</h3>');
                                body.append(clone);

                                return html;
                            }
                        });

                        $(declinePopup).on('click', '.btn-ok', function () {
                            declineReason.val(clone.val());
                            $this.trigger('click'); 
                        });
                        
                        return;
                    }
                }
                
                if (action === 'template-rows' || action === 'template-request'){
                    shouldSave = false;
                    
                    var templatePopup = MDB.modal({
                        buttons: [
                            sprintf('<button type="button" class="btn btn-primary btn-ok">%s</button>', $this.data('okButton'))
                        ] ,
                        shapeHtml: function (html) {
                            html.find('.modal-body').addClass('loading');
                        }
                    });

                    templatePopup = $(templatePopup);
                    
                    $.ajax({
                        url: $this.data('formUrl'),
                        success: function (html) {
                            html = $(html);
                           
                            var body = templatePopup.find('.modal-body');
                            body.removeClass('loading');
                            body.html(html);
                           
                            html.find('.dropdown-single').kendoDropDownList();
                            html.find('.dropdown-multi').kendoMultiSelect({
                                autoClose: false,
                                filter: 'contains'
                            });
                           
                            MDB.DPN.Offers.Requests.bindToggleableSelections(html);

                            // html.find('[name$="IsNewSite"]').on('click', function () {
                            //     MDB.DPN.Offers.Requests.toggleSiteSelection(html);
                            // });
                        },
                        error: function (err) {
                            MDB.alert(err.statusText);
                        }
                    });
                    
                    templatePopup.on('click', '.btn-ok', function () {
                        templatePopup.find('form.template-form').submit();
                    });
                }

                if (shouldSave){
                    MDB.DPN.Offers.Requests.submitRequestForm(form, $this);
                }
            });
            
            if (!model.IsNew) {
                if (model.Status === 0) {
                    MDB.DPN.Offers.Requests.initializeConceptsGrid('.concept-rows-grid', model);
                    
                    grids.push('.concept-rows-grid');
                } else{
                    MDB.DPN.Offers.Requests.initializeBanRowGrid('.ban-rows-grid', model);
                    MDB.DPN.Offers.Requests.initializeP5RowGrid('.p5-rows-grid', model);
                    MDB.DPN.Offers.Requests.initializeBabRowGrid('.bab-rows-grid', model);
                    MDB.DPN.Offers.Requests.initializeCampaignsGrid('.campaign-rows-grid', model);

                    grids.push('.campaign-rows-grid', '.p5-rows-grid','.ban-rows-grid');
                }
            }
        },
        submitRequestForm: function (form, context) {
            var $context = $(context);
            
            form.find('[name="SaveAction"]').val($context.data('save-action'));
            form.find('[name="Status"]').val($context.data('request-status'));

            if (form.valid()){
                form.submit();
            }
        },
        bindToggleableSelections: function(form){
            form.on('change', '.custom-selection-toggle', function () {
                var container = $(this).closest('.custom-selection-container');
                
                var hiddenContainer = container.find('.control-container.hidden')
                    , displayedContainer = container.find('.control-container:not(.hidden)')
                    , hiddenInput = hiddenContainer.find('input') 
                    , displayedInput = displayedContainer.find('input');

                displayedContainer.addClass('hidden');
                hiddenContainer.removeClass('hidden');
                
                var displayedKControl = displayedInput.data('kendoDropDownList');
                var hiddenKControl = hiddenInput.data('kendoDropDownList');

                if (displayedKControl) {
                    displayedKControl.enable(false);
                }
                if (hiddenKControl) {
                    hiddenKControl.enable(true);
                }
                
                displayedInput.attr('disabled', 'disabled');
                hiddenInput.attr('disabled', null);
            });
        },
        initializeBanRowGrid: function (selector, model) {
            var grid = $(selector);

            var gridConfig = {
                dataSource: new kendo.data.DataSource({
                    pageSize: 20,
                    transport: {
                        read: function (opts) {
                            MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + sprintf('/RequestRows?requestId=%s&type=ban', model.Id), 'GET', opts);
                        },
                        update: function (opts) {
                            MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + '/RequestRow', 'PUT', shapeData(opts, model));
                        },
                        create: function (opts) {
                            MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + '/RequestRow', 'POST', shapeData(opts, model));
                        }
                    },
                    schema: {
                        model: {
                            'id': 'Id',
                            fields: {
                                Id: {type: 'number'},
                                GroupingId: {},
                                ProductName: { defaultValue: MDB.DPN.Offers.defaultBanTitle },
                                ProductId: {},
                                TypeName: {editable: false},
                                Type: {},
                                Duration: {},
                                Price: {type: 'number' },
                                PriceUnit: {},
                                PriceUnitName: {editable: false},
                                DiscountPercentage: {type: 'number'},
                                Premium: {editable: false},
                                PremiumId: {type: 'number' },
                                PromotionType: {},
                                ChannelIds: {},
                                Source: {},
                                SupplierName: {},
                                SupplierId: {},
                                Prom: {type: 'number', editable: false},
                                Prke: {type: 'number'},
                                BanP5Prom: {type: 'number'},
                                BanP5Prke: {type: 'number'},
                                Comment: {},
                                Status: {type: 'number'},
                                PrkeValues: {},
                                PrkeName: {editable: false}
                            }
                        }
                    }
                }),
                pageable: MDB.KendoConfigBuilder.gridPageableSettings(),
                columns: [{
                    field: 'Id',
                    hidden: true
                },{
                    field: 'GroupingId',
                    hidden: true
                }, {
                    field: 'ProductId',
                    title: MDB.loadResourceString('OfferRequestRowModel_ProductName_DisplayName'),
                    editor: function(container, opts){
                        dropdownEditor(container, opts, function(model, option) {
                            model['ProductName'] = option.Text; 
                        }, 'TitleIds-ban');
                    },
                    template: function (model) {
                        return dropdownDisplayValue(model, 'ProductId', 'TitleIds-ban'); 
                    },
                    width: 100
                }, {
                    field: 'ProductName',
                    hidden: true,
                    title: MDB.loadResourceString('OfferRequestRowModel_ProductName_DisplayName')
                }, {
                    field: 'Type',
                    title: MDB.loadResourceString('OfferRequestRowModel_TypeName_DisplayName'),
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'Type'); 
                    },
                    width: 150
                }, {
                    field: 'Duration',
                    title: MDB.loadResourceString('OfferRequestRowModel_DurationName_DisplayName'),
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'Duration'); 
                    },
                    width: 100
                },  {
                    field: 'Price',
                    title: MDB.loadResourceString('OfferRequestRowModel_Price_DisplayName'),
                    format: '{0:c}',
                    width: 125
                }, {
                    field: 'PriceUnit',
                    title: MDB.loadResourceString('OfferRequestRowModel_PriceUnitName_DisplayName'),
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'PriceUnit'); 
                    },
                    width: 125
                },{
                    field: 'DiscountPercentage',
                    title: MDB.loadResourceString('OfferRequestRowModel_DiscountPercentage_DisplayName'),
                    template: '#= _.isNumber(DiscountPercentage) ? kendo.format("{0:p}", DiscountPercentage / 100) : ""#',
                    width: 100
                },{
                    field: 'PremiumId',
                    title: MDB.loadResourceString('OfferRequestRowModel_Premium_DisplayName'),
                    template: function (model) {
                        return dropdownDisplayValue(model,  'PremiumId') 
                    },
                    editor: dropdownEditor,
                    width: MDB.KendoConfigBuilder.largeColumnWidth
                }, {
                    field: 'PromotionType',
                    title: MDB.loadResourceString('OfferRequestRowModel_PromotionType_DisplayName'),
                    editor: customDropdownEditor,
                    // template: function (model) { return dropdownDisplayValue(model,  'PromotionType'); },
                    width: MDB.KendoConfigBuilder.largeColumnWidth
                },  {
                    field: 'ChannelIds',
                    title: MDB.loadResourceString('OfferRequestRowModel_Channel_DisplayName'),
                    editor: multiSelectEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'ChannelIds'); 
                    },
                    width: 150
                }, {
                    field: 'Source',
                    title: MDB.loadResourceString('OfferRequestRowModel_Source_DisplayName'),
                    editor: customDropdownEditor,
                    width: 150
                }, {
                    field: 'SupplierId',
                    title: MDB.loadResourceString('OfferRequestRowModel_SupplierName_DisplayName'),
                    editor: function(container, opts){
                        dropdownEditor(container,  opts,  function (model, option) {
                            model.SupplierName = option.Text; 
                        })
                    },
                    template: function (model) {
                        return dropdownDisplayValue(model,  'SupplierId'); 
                    },
                    width: MDB.KendoConfigBuilder.largeColumnWidth
                }, {
                    field: 'Prom',
                    title: MDB.loadResourceString('OfferRequestRowModel_Prom_DisplayName'),
                    width: 75
                },{
                    field: 'Prke',
                    title: MDB.loadResourceString('OfferRequestRowModel_Prke_DisplayName'),
                    width: 325
                }, {
                    field: 'PrkeName',
                    title: MDB.loadResourceString('OfferRequestRowModel_PrkeName_DisplayName'),
                    width: MDB.KendoConfigBuilder.mediumLargeColumnWidth
                }, {
                    field: 'BanP5Prom',
                    title: 'BanP5Prom',
                    width: 100
                }, {
                    field: 'BanP5Prke',
                    title: MDB.loadResourceString('OfferRequestRowModel_BanP5Prke_DisplayName'),
                    width: 100
                }, {
                    field: 'Comment',
                    title: MDB.loadResourceString('OfferRequestRowModel_Comment_DisplayName'),
                    width: MDB.KendoConfigBuilder.largeColumnWidth
                }, {
                    field: 'Labels',
                    title: 'Labels',
                    width: MDB.KendoConfigBuilder.mediumColumnWidth,
                    template: function(model){
                        return (model.Labels || []).join(', ');
                    },
                    editor: function (container, opts) {
                        container.append($('<select />'));

                        var kLabelSelector = MDB.KendoConfigBuilder.extendablebleMultiDropdown(container.find('select'), {
                            change: function () {
                                opts.model.set('Labels', this.value()); 
                            },
                            dataTextField: 'text',
                            dataValueField: 'value',
                            dataSource: MDB.KendoConfigBuilder.arrayDataSource(opts.model.Labels)
                        });

                        kLabelSelector.value(opts.model.Labels);
                    }
                }, {
                    field: 'Status',
                    title: 'Goedgekeurd/Afgekeurd',
                    width: 200
                }],
                messages: {
                    commands: MDB.KendoConfigBuilder.commandLabels(),
                    noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
                },
                toolbar: ['excel'],
                navigatable: true,
                sortable: { mode: 'multiple' },
                scrollable: true,
                editable: true
            };
            
            MDB.DPN.Offers.Requests.initReviewGrid(grid, gridConfig, model, 'ban');
        },
        initializeP5RowGrid: function (selector, model) {
            var grid = $(selector);

            var gridConfig = {
                dataSource: new kendo.data.DataSource({
                    pageSize: 10,
                    transport: {
                        read: function (opts) {
                            MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + sprintf('/RequestRows?requestId=%s&type=p5', model.Id), 'GET', opts);
                        },
                        update: function (opts) {
                            MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + '/P5RequestRow', 'PUT', shapeData(opts, model));
                        },
                        create: function(opts) {
                            MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + '/RequestRow', 'POST', shapeData(opts, model));
                        }
                    },
                    schema: {
                        model: {
                            'id': 'GroupingId',
                            fields: {
                                Ids: {editable: false},
                                GroupingId: {},
                                ProductName: { },
                                ProductId: { defaultValue: MDB.DPN.Offers.defaultP5TitleId },
                                TypeName: {editable: false},
                                Type: {},
                                Duration: {},
                                Price: {type: 'number' },
                                PriceUnit: {},
                                PriceUnitName: {editable: false},
                                DiscountPercentage: {type: 'number'},
                                Premium: {editable: false},
                                PremiumId: {type: 'number'},
                                PromotionType: {},
                                ChannelIds: {},
                                Source: {},
                                SupplierName: {},
                                SupplierId: {},
                                Werfsleutel: {},
                                Abosoort: {},
                                Verschijnwijze: {},
                                Betaalwijze: {},
                                Betaalfrequentie: {},
                                Prijsgroep: {},
                                Premie: {},
                                Premiegroep: {},
                                Looptijd: {type: 'number'},
                                Periode: {},
                                Omschrijving: {},
                                Medium: {},
                                FollowUp: {},
                                Prke: {type: 'number'},
                                BanP5Prke: {type: 'number'},
                                BanP5Prom: {type: 'number' },
                                Comment: {},
                                Labels: {},
                                Status: {type: 'number'},
                                PrkeValues: {},
                                PrkeName: {editable: false}
                            }
                        }
                    }
                }),
                pageable: MDB.KendoConfigBuilder.gridPageableSettings(),
                columns: [{
                    field: 'Ids',
                    hidden: true
                },{
                    field: 'GroupingId',
                    hidden: true
                },{
                    field: 'ProductId',
                    hidden: true
                }, {
                    field: 'ProductName',
                    title: MDB.loadResourceString('OfferRequestRowModel_ProductName_DisplayName'),
                    editor: function(container, opts){
                        dropdownEditor(container, opts, function(model, option) {
                            model['ProductId'] = MDB.DPN.Offers.getTitleId(option.Value); 
                        }, 'ProductNames-p5') 
                    },
                    width: 100
                }, {
                    field: 'Type',
                    title: MDB.loadResourceString('OfferRequestRowModel_TypeName_DisplayName'),
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'Type'); 
                    },
                    width: 150
                }, {
                    field: 'Duration',
                    title: MDB.loadResourceString('OfferRequestRowModel_DurationName_DisplayName'),
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'Duration'); 
                    },
                    width: 100
                },  {
                    field: 'Price',
                    title: MDB.loadResourceString('OfferRequestRowModel_Price_DisplayName'),
                    format: '{0:c}',
                    width: 125
                }, {
                    field: 'PriceUnit',
                    title: MDB.loadResourceString('OfferRequestRowModel_PriceUnitName_DisplayName'),
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'PriceUnit'); 
                    },
                    width: 125
                },{
                    field: 'DiscountPercentage',
                    title: MDB.loadResourceString('OfferRequestRowModel_DiscountPercentage_DisplayName'),
                    template: '#= _.isNumber(DiscountPercentage) ? kendo.format("{0:p}", DiscountPercentage / 100) : ""#',
                    width: 100
                }, {
                    field: 'PremiumId',
                    title: MDB.loadResourceString('OfferRequestRowModel_Premium_DisplayName'),
                    template: function (model) {
                        return dropdownDisplayValue(model,  'PremiumId') 
                    },
                    editor: dropdownEditor,
                    width: MDB.KendoConfigBuilder.largeColumnWidth
                },{
                    field: 'PromotionType',
                    title: MDB.loadResourceString('OfferRequestRowModel_PromotionType_DisplayName'),
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'PromotionType'); 
                    },
                    width: MDB.KendoConfigBuilder.largeColumnWidth
                },  {
                    field: 'ChannelIds',
                    title: MDB.loadResourceString('OfferRequestRowModel_Channel_DisplayName'),
                    editor: multiSelectEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'ChannelIds'); 
                    },
                    width: 150
                }, {
                    field: 'Source',
                    title: MDB.loadResourceString('OfferRequestRowModel_Source_DisplayName'),
                    editor: customDropdownEditor,
                    width: 150
                }, {
                    field: 'SupplierId',
                    title: MDB.loadResourceString('OfferRequestRowModel_SupplierName_DisplayName'),
                    editor: function(container, opts){
                        dropdownEditor(container,  opts,  function (model, option) {
                            model.SupplierName = option.Text; 
                        })
                    },
                    template: function (model) {
                        return dropdownDisplayValue(model,  'SupplierId')
                    },
                    width: MDB.KendoConfigBuilder.largeColumnWidth
                }, {
                    field: 'Prke',
                    title: MDB.loadResourceString('OfferRequestRowModel_Prke_DisplayName'),
                    width: 325
                }, {
                    field: 'PrkeName',
                    title: MDB.loadResourceString('OfferRequestRowModel_PrkeName_DisplayName'),
                    width: MDB.KendoConfigBuilder.largeColumnWidth
                },{
                    field: 'BanP5Prom',
                    title: 'BanP5Prom',
                    width: 100
                }, {
                    field: 'BanP5Prke',
                    title: MDB.loadResourceString('OfferRequestRowModel_BanP5Prke_DisplayName'),
                    width: 100
                }, {
                    field: 'Werfsleutel',
                    title: MDB.loadResourceString('OfferRequestP5RowModel_Werfsleutel_DisplayName'),
                    width: 100,
                    editor: disableTextboxEditorWhenBanP5PrkeIsPresent
                },{
                    field: 'Abosoort',
                    title: MDB.loadResourceString('OfferRequestP5RowModel_Abosoort_DisplayName'),
                    width: 100,
                    editor: disableTextboxEditorWhenBanP5PrkeIsPresent
                }, {
                    field: 'Verschijnwijze',
                    title: MDB.loadResourceString('OfferRequestP5RowModel_Verschijnwijze_DisplayName'),
                    width: MDB.KendoConfigBuilder.largeColumnWidth,
                    editor: disableDropdownEditorWhenBanP5PrkeIsPresent,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'Verschijnwijze'); 
                    }
                }, {
                    field: 'Betaalwijze',
                    title: MDB.loadResourceString('OfferRequestP5RowModel_Betaalwijze_DisplayName'),
                    width: MDB.KendoConfigBuilder.largeColumnWidth,
                    editor: disableDropdownEditorWhenBanP5PrkeIsPresent,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'Betaalwijze'); 
                    }
                }, {
                    field: 'Betaalfrequentie',
                    title: MDB.loadResourceString('OfferRequestRowModel_PriceUnitName_DisplayName'),
                    width: MDB.KendoConfigBuilder.largeColumnWidth,
                    editor: disableDropdownEditorWhenBanP5PrkeIsPresent,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'Betaalfrequentie'); 
                    }
                }, {
                    field: 'Prijsgroep',
                    title: MDB.loadResourceString('OfferRequestP5RowModel_Prijsgroep_DisplayName'),
                    width: 100,
                    editor: disableTextboxEditorWhenBanP5PrkeIsPresent
                }, {
                    field: 'Premie',
                    title: MDB.loadResourceString('OfferRequestP5RowModel_Premie_DisplayName'),
                    width: MDB.KendoConfigBuilder.largeColumnWidth,
                    editor: disableDropdownEditorWhenBanP5PrkeIsPresent,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'Premie'); 
                    }
                }, {
                    field: 'Premiegroep',
                    title: MDB.loadResourceString('OfferRequestP5RowModel_Premiegroep_DisplayName'),
                    width: MDB.KendoConfigBuilder.largeColumnWidth,
                    editor: disableDropdownEditorWhenBanP5PrkeIsPresent,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'Premiegroep'); 
                    }
                }, {
                    field: 'Looptijd',
                    title: MDB.loadResourceString('OfferRequestRowModel_DurationName_DisplayName'),
                    width: 100,
                    editor: disableNumberEditorWhenBanP5PrkeIsPresent
                }, {
                    field: 'Periode',
                    title: MDB.loadResourceString('OfferRequestP5RowModel_Periode_DisplayName'),
                    width: 150,
                    editor: disableDropdownEditorWhenBanP5PrkeIsPresent,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'Periode'); 
                    }
                }, {
                    field: 'Omschrijving',
                    title: MDB.loadResourceString('OfferRequestP5RowModel_Omschrijving_DisplayName'),
                    width: MDB.KendoConfigBuilder.largeColumnWidth,
                    editor: disableTextboxEditorWhenBanP5PrkeIsPresent
                }, {
                    field: 'Medium',
                    title: MDB.loadResourceString('OfferRequestP5RowModel_Medium_DisplayName'),
                    width: 150,
                    editor: disableDropdownEditorWhenBanP5PrkeIsPresent,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'Medium'); 
                    }
                }, {
                    field: 'FollowUp',
                    title: MDB.loadResourceString('OfferRequestP5RowModel_FollowUp_DisplayName'),
                    width: 75,
                    template: MDB.KendoConfigBuilder.gridBooleanYesNoTemplate('FollowUp'),
                    editor: disableCheckboxEditorWhenBanP5PrkeIsPresent
                },{
                    title: 'P5 PRKE aanmaken',
                    width: 100,
                    template: function (model) { 
                        return model.BanP5Prke ? '' : '<a class="k-button k-button-icontext" href="#"><span class="grid-icon fa fa-lg fa-plus-circle new-p5-prke"/></a>'
                    }
                }, {
                    field: 'Comment',
                    title: MDB.loadResourceString('OfferRequestRowModel_Comment_DisplayName'),
                    width: MDB.KendoConfigBuilder.largeColumnWidth,
                    editor: disableTextboxEditorWhenBanP5PrkeIsPresent
                }, {
                    field: 'Labels',
                    title: 'Labels',
                    width: MDB.KendoConfigBuilder.mediumColumnWidth,
                    template: function(model){
                        return (model.Labels || []).join(', ');
                    },
                    editor: function (container, opts) {
                        container.append($('<select />'));

                        var kLabelSelector = MDB.KendoConfigBuilder.extendablebleMultiDropdown(container.find('select'), {
                            change: function () {
                                opts.model.set('Labels', this.value()); 
                            },
                            dataTextField: 'text',
                            dataValueField: 'value',
                            dataSource: MDB.KendoConfigBuilder.arrayDataSource(opts.model.Labels)
                        });

                        kLabelSelector.value(opts.model.Labels);
                    }
                }, {
                    field: 'Status',
                    title: 'Goedgekeurd/Afgekeurd',
                    width: 200
                }],
                messages: {
                    commands: MDB.KendoConfigBuilder.commandLabels(),
                    noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
                },
                toolbar: ['excel'],
                navigatable: true,
                sortable: { mode: 'multiple' },
                scrollable: true,
                editable: true
            };
            
            function disableCheckboxEditorWhenBanP5PrkeIsPresent(container, opts){
                disableEditorWhenBanP5PrkeIsPresent(container,  opts,  MDB.KendoConfigBuilder.gridCheckboxEditor, function (opts) {
                    //Mimic display template rendering
                    var template = MDB.KendoConfigBuilder.gridBooleanYesNoTemplate(opts.field);
                    var kTemplate = new kendo.template(template);
                    return kTemplate(opts.model);
                });
            }

            function disableTextboxEditorWhenBanP5PrkeIsPresent(container, opts){
                disableEditorWhenBanP5PrkeIsPresent(container,  opts,  function (container, opts) {
                    $('<input class="k-input k-textbox" type="text" data-bind="value:' + opts.field + '"/>')
                        .appendTo(container);
                });
            }

            function disableDropdownEditorWhenBanP5PrkeIsPresent(container, opts){
                disableEditorWhenBanP5PrkeIsPresent(container,  opts,  dropdownEditor, function () {
                    return dropdownDisplayValue(opts.model, opts.field);
                });
            }

            function disableNumberEditorWhenBanP5PrkeIsPresent(container, opts){
                disableEditorWhenBanP5PrkeIsPresent(container,  opts,  function (container, opts) {
                    var field = gridConfig.dataSource.options.schema.model.fields[opts.field];
                    
                    $('<input data-bind="value:' + opts.field + '"/>')
                        .appendTo(container)
                        .kendoNumericTextBox(field);
                });
            }
            
            function disableEditorWhenBanP5PrkeIsPresent(container, opts, fnEditor, fnGetDisplayValue) {
                //Require a PRKE, but not a BanP5Prke
                if (opts.model.BanP5Prke || !opts.model.Prke) {
                    fnGetDisplayValue = fnGetDisplayValue || function (opts) {
                        return opts.model[opts.field]; 
                    };
                    
                    var $container = $(container);
                    
                    $container.removeClass('k-edit-cell');
                    $container.text(fnGetDisplayValue(opts));
                    
                    return;
                }
                
                if (fnEditor) {
                    return fnEditor(container, opts);
                }
            }
            
            //Values that can only conditionally be set should be ignored
            var ignoredValueOverrideColumns = _.filter(gridConfig.columns, function (c) {
                return [
                    disableTextboxEditorWhenBanP5PrkeIsPresent,
                    disableDropdownEditorWhenBanP5PrkeIsPresent, 
                    disableCheckboxEditorWhenBanP5PrkeIsPresent,
                    disableNumberEditorWhenBanP5PrkeIsPresent
                ].indexOf(c.editor) !== -1;
            });
            
            MDB.DPN.Offers.Requests.initReviewGrid(
                grid, 
                gridConfig, 
                model, 
                'p5',
                _.map(ignoredValueOverrideColumns, 'field')
            );
        },
        initializeBabRowGrid: function(selector, model){
            var grid = $(selector);

            var gridConfig = {
                dataSource: new kendo.data.DataSource({
                    pageSize: 20,
                    transport: {
                        read: function (opts) {
                            MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + sprintf('/RequestRows?requestId=%s&type=bab', model.Id), 'GET', opts);
                        },
                        update: function (opts) {
                            MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + '/BabRequestRow', 'PUT', shapeData(opts, model));
                        },
                        create: function (opts) {
                            MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + '/BabRequestRow', 'POST', shapeData(opts, model));
                        }
                    },
                    schema: {
                        model: {
                            'id': 'Id',
                            fields: {
                                Id: {type: 'number'},
                                GroupingId: {},
                                ProductName: { defaultValue: MDB.DPN.Offers.defaultBabTitle },
                                ProductId: {},
                                TypeName: {editable: false},
                                Type: {},
                                Duration: {},
                                Price: {type: 'number' },
                                PriceUnit: {},
                                PriceUnitName: {editable: false},
                                DiscountPercentage: {type: 'number'},
                                Premium: {editable: false},
                                PremiumId: {type: 'number' },
                                PromotionType: {},
                                ChannelIds: {},
                                Source: {},
                                SupplierName: {},
                                SupplierId: {},
                                Prom: {type: 'number', editable: false},
                                Prke: {type: 'number'},
                                BanP5Prom: {type: 'number'},
                                BanP5Prke: {type: 'number'},
                                PaymentMethod: {},
                                DistributionMethod: {},
                                Comment: {},
                                Status: {type: 'number'},
                                PrkeValues: {},
                                PrkeName: {editable: false}
                            }
                        }
                    }
                }),
                pageable: MDB.KendoConfigBuilder.gridPageableSettings(),
                columns: [{
                    field: 'Id',
                    hidden: true
                },{
                    field: 'GroupingId',
                    hidden: true
                }, {
                    field: 'ProductId',
                    title: MDB.loadResourceString('OfferRequestRowModel_ProductName_DisplayName'),
                    editor: function(container, opts){
                        dropdownEditor(container, opts, function(model, option) {
                            model['ProductName'] = option.Text; 
                        }, 'TitleIds-bab');
                    },
                    template: function (model) {
                        return dropdownDisplayValue(model, 'ProductId', 'TitleIds-bab'); 
                    },
                    width: 100
                }, {
                    field: 'ProductName',
                    hidden: true,
                    title: MDB.loadResourceString('OfferRequestRowModel_ProductName_DisplayName')
                }, {
                    field: 'Type',
                    title: MDB.loadResourceString('OfferRequestRowModel_TypeName_DisplayName'),
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'Type'); 
                    },
                    width: 150
                }, {
                    field: 'Duration',
                    title: MDB.loadResourceString('OfferRequestRowModel_DurationName_DisplayName'),
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'Duration'); 
                    },
                    width: 100
                },  {
                    field: 'Price',
                    title: MDB.loadResourceString('OfferRequestRowModel_Price_DisplayName'),
                    format: '{0:c}',
                    width: 125
                }, {
                    field: 'PriceUnit',
                    title: MDB.loadResourceString('OfferRequestRowModel_PriceUnitName_DisplayName'),
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'PriceUnit'); 
                    },
                    width: 125
                },{
                    field: 'DiscountPercentage',
                    title: MDB.loadResourceString('OfferRequestRowModel_DiscountPercentage_DisplayName'),
                    template: '#= _.isNumber(DiscountPercentage) ? kendo.format("{0:p}", DiscountPercentage / 100) : ""#',
                    width: 100
                },{
                    field: 'PremiumId',
                    title: MDB.loadResourceString('OfferRequestRowModel_Premium_DisplayName'),
                    template: function (model) {
                        return dropdownDisplayValue(model,  'PremiumId') 
                    },
                    editor: dropdownEditor,
                    width: MDB.KendoConfigBuilder.largeColumnWidth
                }, {
                    field: 'PromotionType',
                    title: MDB.loadResourceString('OfferRequestRowModel_PromotionType_DisplayName'),
                    editor: customDropdownEditor,
                    // template: function (model) { return dropdownDisplayValue(model,  'PromotionType'); },
                    width: MDB.KendoConfigBuilder.largeColumnWidth
                },  {
                    field: 'ChannelIds',
                    title: MDB.loadResourceString('OfferRequestRowModel_Channel_DisplayName'),
                    editor: multiSelectEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'ChannelIds'); 
                    },
                    width: 150
                }, {
                    field: 'Source',
                    title: MDB.loadResourceString('OfferRequestRowModel_Source_DisplayName'),
                    editor: customDropdownEditor,
                    width: 150
                }, {
                    field: 'SupplierId',
                    title: MDB.loadResourceString('OfferRequestRowModel_SupplierName_DisplayName'),
                    editor: function(container, opts){
                        dropdownEditor(container,  opts,  function (model, option) {
                            model.SupplierName = option.Text; 
                        })
                    },
                    template: function (model) {
                        return dropdownDisplayValue(model,  'SupplierId'); 
                    },
                    width: MDB.KendoConfigBuilder.largeColumnWidth
                }, {
                    field: 'Prom',
                    title: MDB.loadResourceString('OfferRequestRowModel_Prom_DisplayName'),
                    width: 75
                },{
                    field: 'Prke',
                    title: MDB.loadResourceString('OfferRequestRowModel_Prke_DisplayName'),
                    width: 325
                }, {
                    field: 'PrkeName',
                    title: MDB.loadResourceString('OfferRequestRowModel_PrkeName_DisplayName'),
                    width: MDB.KendoConfigBuilder.mediumLargeColumnWidth
                }, {
                    field: 'BanP5Prom',
                    title: 'BanP5Prom',
                    width: 100
                }, {
                    field: 'BanP5Prke',
                    title: MDB.loadResourceString('OfferRequestRowModel_BanP5Prke_DisplayName'),
                    width: 100
                }, {
                    field: 'PaymentMethod',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_PaymentMethod_DisplayName'),
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'PaymentMethod'); 
                    },
                    width: MDB.KendoConfigBuilder.mediumLargeColumnWidth
                }, {
                    field: 'DistributionMethod',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_DistributionMethod_DisplayName'),
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'DistributionMethod'); 
                    },
                    width: MDB.KendoConfigBuilder.mediumLargeColumnWidth
                },{
                    field: 'Comment',
                    title: MDB.loadResourceString('OfferRequestRowModel_Comment_DisplayName'),
                    width: MDB.KendoConfigBuilder.largeColumnWidth
                }, {
                    field: 'Labels',
                    title: 'Labels',
                    width: MDB.KendoConfigBuilder.mediumColumnWidth,
                    template: function(model){
                        return (model.Labels || []).join(', ');
                    },
                    editor: function (container, opts) {
                        container.append($('<select />'));

                        var kLabelSelector = MDB.KendoConfigBuilder.extendablebleMultiDropdown(container.find('select'), {
                            change: function () {
                                opts.model.set('Labels', this.value()); 
                            },
                            dataTextField: 'text',
                            dataValueField: 'value',
                            dataSource: MDB.KendoConfigBuilder.arrayDataSource(opts.model.Labels)
                        });

                        kLabelSelector.value(opts.model.Labels);
                    }
                }, {
                    field: 'Status',
                    title: 'Goedgekeurd/Afgekeurd',
                    width: 200
                }],
                messages: {
                    commands: MDB.KendoConfigBuilder.commandLabels(),
                    noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
                },
                toolbar: ['excel'],
                navigatable: true,
                sortable: { mode: 'multiple' },
                scrollable: true,
                editable: true
            };

            MDB.DPN.Offers.Requests.initReviewGrid(grid, gridConfig, model, 'bab');
        },
        initializeCampaignsGrid: function (selector, model) {
            var grid = $(selector);

            var gridConfig = {
                dataSource: new kendo.data.DataSource({
                    pageSize: 20,
                    transport: {
                        read: function (opts) {
                            MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + sprintf('/RequestRows?requestId=%s&type=Campaigns', model.Id), 'GET', opts);
                        },  
                        create: function (opts) {
                            opts.data.RequestId = model.Id;
                            var isValid = !model.Verkoopkanalen || model.Verkoopkanalen.length == 2 || /^[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}$/.test(model.Verkoopkanalen) || /^[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}$/.test(model.Verkoopkanalen);
                            
                            if(!opts.data.CampaignName || !isValid) {
                                // just pretend we were successful
                                opts.success(opts.data);
                            } else {
                                MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + sprintf('/Campaign', model.Id), 'POST', opts);
                            } 
                        },
                        update: function (opts) {
                            //opts.success(opts.data);
                            opts.data.RequestId = model.Id;
                            var isValid = !model.Verkoopkanalen || model.Verkoopkanalen.length == 2 || /^[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}$/.test(model.Verkoopkanalen) || /^[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}$/.test(model.Verkoopkanalen);
                            
                            if(!opts.data.CampaignName || !isValid) {
                                // just pretend we were successful
                                opts.success(opts.data);
                            } else {
                                MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + sprintf('/Campaign', model.Id), 'PUT', opts);
                            } 

                        }
                    },
                    schema: {
                        model: {
                            'id': 'CampaignId',
                            fields: {
                                RequestId: {editable: false, type: 'number'},
                                CampaignId: {editable: false},
                                CampaignName: {},
                                SupplierId: {},
                                ChannelIds: {},
                                RecruitmentTag: {},
                                Verkoopkanalen: {},
                                ShouldExport: {type: 'boolean'}
                            }
                        }
                    },
                    autoSync: true
                }),
                pageable: MDB.KendoConfigBuilder.gridPageableSettings(),
                columns: [{
                    field: 'RequestId',
                    hidden: true
                },{
                    field: 'CampaignId',
                    title: 'Id'
                },{
                    field: 'CampaignName',
                    title: 'Naam',
                    attributes: { 'class': 'cell-editable' }
                }, {
                    field: 'SupplierId',
                    title: 'Leverancier',
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model, 'SupplierId')  
                    },
                    attributes: { 'class': 'cell-editable' }
                }, {
                    field: 'ChannelIds',
                    title: 'Kanaal',
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model, 'ChannelIds')  
                    },
                    attributes: { 'class': 'cell-editable' }
                }, {
                    field: 'RecruitmentTag',
                    title: 'RecruitmentTag',
                    attributes: { 'class': 'cell-editable' }
                }, {
                    field: 'Verkoopkanalen',
                    title: 'Verkoopkanalen',
                    attributes: { 'class': 'cell-editable' },
                    editor: function (container, opts) {
                        var seperator = '-'
                            , seperatorRegex = /-/g
                            , verkoopKanaalLength = 2
                            , maxInputLength = 8;
                        
                        var editor = MDB.KendoConfigBuilder.gridTextBoxEditor(container, opts,  {
                            'maxlength': maxInputLength
                        });
                        
                        
                        editor.on('keyup', function(e){
                            if (!/^[a-zA-Z]$/.test(e.key)){
                                return;
                            }
                            
                            var value = this.value.replace(seperatorRegex, '');

                            var values =_.map(_.range(verkoopKanaalLength, maxInputLength, verkoopKanaalLength), function(index){
                                return value.substring(index - verkoopKanaalLength, index);
                            });

                            this.value = _.filter(values).join(seperator); 
                        });
                    }
                }, {
                    field: 'ShouldExport',
                    title: 'Meenemen in totaal export',
                    template: MDB.KendoConfigBuilder.gridBooleanYesNoTemplate('ShouldExport'),
                    attributes: { 'class': 'cell-editable' }
                }],
                messages: {
                    commands: MDB.KendoConfigBuilder.commandLabels(),
                    noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
                },
                toolbar: ['create'],
                navigatable: true,
                sortable: { mode: 'multiple' },
                scrollable: false,
                editable: true
            };

            if (!model.EnableRowEditing){
                MDB.DPN.Offers.Requests.removeEditOptions(gridConfig);
            }
            
            grid.kendoGrid(gridConfig);
        },
        initializeConceptsGrid: function(selector, model){
            var grid = $(selector);
            
            var titleDropdown = dropdownConfigs['TitleIds'];
            var titleDropdownValues = _.map(titleDropdown.dataSource.data, 'Text');
            
            titleDropdownValues.push('WEG');
            
            titleDropdown.dataSource.data = _.map(titleDropdownValues, function (item) {
                return {
                    Text: item,
                    Value: item
                }
            });
            
            var gridConfig = {
                dataSource: new kendo.data.DataSource({
                    pageSize: 20,
                    transport: {
                        read: function (opts) {
                            MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + sprintf('/RequestRows?requestId=%s&type=grouping', model.Id), 'GET', opts);
                        },
                        create: function (opts) {
                            MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + '/RequestRows', 'POST', shapeData(opts, model));
                        },
                        update: function (opts) {
                            MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + '/RequestRows', 'PUT', shapeData(opts, model));
                        },
                        destroy: function (opts) {
                            MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + '/RequestRows?groupingid=' + opts.data.GroupingId, 'DELETE', opts);
                        }
                    },
                    schema: {
                        model: {
                            'id': 'GroupingId',
                            fields: {
                                GroupingId: {},
                                RequestId: {type: 'number'},
                                TitleIds: {},
                                Type: {},
                                Duration: {},
                                Price: {type: 'number'},
                                PriceUnit: {},
                                DiscountPercentage: {type: 'number', defaultValue: null},
                                PremiumId: {type: 'number'},
                                PromotionType: {},
                                ChannelIds: {},
                                Source: {},
                                SupplierId: {}
                            }
                        }
                    }
                }),
                pageable: MDB.KendoConfigBuilder.gridPageableSettings(),
                columns: [{
                    field: 'GroupingId',
                    hidden: true
                }, {
                    field: 'TitleIds',
                    title: MDB.loadResourceString('OfferRequestRowModel_ProductName_DisplayName'),
                    editor: multiSelectEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'TitleIds'); 
                    },
                    width: 100
                }, {
                    field: 'Type',
                    title: MDB.loadResourceString('OfferRequestRowModel_TypeName_DisplayName'),
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'Type'); 
                    },
                    width: 100
                }, {
                    field: 'Duration',
                    title: MDB.loadResourceString('OfferRequestRowModel_DurationName_DisplayName'),
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'Duration'); 
                    },
                    width: 100
                }, {
                    field: 'Price',
                    title: MDB.loadResourceString('OfferRequestRowModel_Price_DisplayName'),
                    format: '{0:c}',
                    width: 125
                }, {
                    field: 'PriceUnit',
                    title: MDB.loadResourceString('OfferRequestRowModel_PriceUnitName_DisplayName'),
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'PriceUnit'); 
                    },
                    width: 125
                }, {
                    field: 'DiscountPercentage',
                    title: MDB.loadResourceString('OfferRequestRowModel_DiscountPercentage_DisplayName'),
                    template: '#= _.isNumber(DiscountPercentage) ? kendo.format("{0:p}", DiscountPercentage / 100) : ""#',
                    width: 100
                }, {
                    field: 'PremiumId',
                    title: MDB.loadResourceString('OfferRequestRowModel_Premium_DisplayName'),
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'PremiumId'); 
                    },
                    width: 100
                }, {
                    field: 'PromotionType',
                    title: MDB.loadResourceString('OfferRequestRowModel_PromotionType_DisplayName'),
                    editor: customDropdownEditor,
                    // template: function (model) { return dropdownDisplayValue(model,  'PromotionType'); },
                    width: 100
                }, {
                    field: 'ChannelIds',
                    title: MDB.loadResourceString('OfferRequestRowModel_Channel_DisplayName'),
                    editor: multiSelectEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'ChannelIds'); 
                    },
                    width: 150
                }, {
                    field: 'Source',
                    title: MDB.loadResourceString('OfferRequestRowModel_Source_DisplayName'),
                    editor: customDropdownEditor,
                    width: 150
                }, {
                    field: 'SupplierId',
                    title: MDB.loadResourceString('OfferRequestRowModel_SupplierName_DisplayName'),
                    editor: dropdownEditor,
                    template: function (model) {
                        return dropdownDisplayValue(model,  'SupplierId'); 
                    },
                    width: 100
                }],
                messages: {
                    commands: MDB.KendoConfigBuilder.commandLabels(),
                    noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
                },
                navigatable: true,
                sortable: { mode: 'multiple' },
                scrollable: false,
                editable: false,
                edit: function () {
                    MDB.DPN.Offers.Requests.allowDuplicates = false;
                }
            };
            
            if (model.EnableRequestEditing){
                gridConfig.toolbar = ['create'];
                gridConfig.editable = 'inline';
                
                MDB.DPN.Offers.Requests.addGridValueOverrideSelector(grid, gridConfig, ['TitleIds']);
                
                gridConfig.columns.push({
                    command: [
                        {
                            name: 'duplicate',
                            text: '',
                            iconClass: 'grid-icon fa fa-lg fa-plus-circle',
                            click: function (e) {
                                e.preventDefault();

                                var ds = this.dataSource;

                                var row = $(e.target).closest('tr[data-uid]');
                                var kModel = ds.getByUid(row.data('uid'));

                                var newModel = {};

                                _.keys(ds.options.schema.model.fields).forEach(function (key) {
                                    var value = kModel[key];
                                    if (multiDropdownFields.indexOf(key) !== -1){
                                        value = value.slice();
                                    }

                                    newModel[key] = value;
                                });

                                newModel.uid = MDB.guid();
                                newModel.id = MDB.guid();
                                newModel.GroupingId = newModel.id;
                                newModel.RequestId = model.Id;
                                
                                newModel = ds.add(newModel);
                                newModel.dirty = true;
                                
                                syncAndReloadGrid(grid);
                            }
                        },
                        {
                            name: 'destroy',
                            text: '',
                            iconClass: 'grid-icon fa fa-lg fa-trash'
                        },
                        {
                            name: 'edit',
                            text: '',
                            iconClass: 'grid-icon fa fa-lg fa-pencil'
                        }
                    ],
                    title: MDB.loadResourceString('OfferRequestGroup_CommandColumn_Title'),
                    width: 180
                });
            }
            
            grid.kendoGrid(gridConfig);

            // MDB.DPN.Offers.Requests.forceColumnMutualExclusivity(grid, gridConfig, 'Price', 'DiscountPercentage');
        },
        addGridValueOverrideSelector: function(grid, gridConfig, ignoredColumns){
            var gridContainer = grid.closest('.grid-container');
            var targetContainer = gridContainer.find('.value-override-container');
            targetContainer = targetContainer.length ? targetContainer : gridContainer; 
            
            var gridWideValueOverrideSupportedColumns = _.filter(gridConfig.columns, function(c) {
                var schemaField = gridConfig.dataSource.options.schema.model.fields[c.field];
                
                //Field is required, can't be hidden, can't be ignored, and can't be defined not editable in the grid's datamodel
                return !!c.field 
                    && !c.hidden 
                    && (!schemaField || schemaField.editable !== false)
                    && ignoredColumns.indexOf(c.field) === -1
            });

            var valueOverrideDropdownOpts = _.map(_.orderBy(gridWideValueOverrideSupportedColumns, 'title'), function (c) {
                return sprintf('<option value="%s">%s</option>', c.field, c.title)
            });

            var valueOverrideContainer = $('<div />', {'class': 'form-group'});
            valueOverrideContainer.append(
                sprintf(
                    '<div class="row"><div class="col-12"><label class="control-label">%s</label></div></div>', 
                    MDB.loadResourceString('OfferRequest_GridValueOverride_Explanation')
                )
            );

            var valueOverrideDropdown = $('<select/>').html(valueOverrideDropdownOpts.join(''));
            var valueOverrideTargetContainer = $('<div />', {'class': 'd-inline-block'});

            valueOverrideContainer
                .append($('<div />', {'class': 'd-inline-block mr-3 text-nowrap'}).html(valueOverrideDropdown))
                .append(valueOverrideTargetContainer);

            targetContainer.prepend(valueOverrideContainer);

            valueOverrideDropdown.kendoDropDownList({
                change: function () {
                    var selectedField = this.value();
                    
                    var column = _.find(gridWideValueOverrideSupportedColumns, { field: selectedField} );
                    var triggerValueOverrideButton = $('<button/>', {'class': 'btn btn-primary ml-3'})
                        .text(MDB.loadResourceString('OfferRequest_GridValueOverride_Button'));
                    
                    valueOverrideTargetContainer.empty();
                    
                    var fnEditor = column.editor;
                    if (!fnEditor || !_.isFunction(fnEditor)){
                        
                        //Simplistic textbox editor stand in for non dropdown fields
                        fnEditor = function (container, opts) {
                            var field = gridConfig.dataSource.options.schema.model.fields[column.field];
                            
                            var control = MDB.KendoConfigBuilder.gridTextBoxEditor(container,  opts, { type: field.type || 'text' });
                            
                            $(control).on('change', function () {
                                opts.model[opts.field] = this.value; 
                            });
                        }
                    }

                    //Fake a kendo model, editor should handle setting of the value
                    var opts = {
                        field: column.field,
                        model: _.extend(_.zipObject(_.filter(_.map(gridConfig.columns, 'field'))), {
                            isNew: function () {
                                return true;
                            }
                        })
                    }; 

                    fnEditor(valueOverrideTargetContainer, opts);
                    valueOverrideTargetContainer.append(triggerValueOverrideButton);

                    //'Fix' styling for non-grid elements
                    valueOverrideContainer.find('.k-multiselect').addClass('k-multiselect-inline-dropdown');
                    valueOverrideContainer.find('.custom-input').css({'width': 'auto'});

                    triggerValueOverrideButton.on('click', function () {
                        var ds = gridConfig.dataSource;
                        
                        _.forEach(ds.data(), function (d) {
                            d.dirty = true;
                            d[column.field] = opts.model[column.field]
                        });

                        syncAndReloadGrid(grid);
                    });
                }
            });
            
            valueOverrideDropdown.data('kendoDropDownList').trigger('change');
        },
        removeEditOptions: function (gridConfig) {
            gridConfig.editable = false;
            var toolbar = gridConfig.toolbar;

            if (toolbar){
                var createOptIndex = toolbar.indexOf('create');

                if (createOptIndex !== -1){
                    toolbar.splice(createOptIndex, 1);
                }
            }
        },
        forceColumnMutualExclusivity: function (grid, gridConfig, targetColumn, otherTargetColumn) {
            $(grid).on('change', sprintf('[name="%s"],[name="%s"]', targetColumn, otherTargetColumn), function (e) {
                var $this = $(this);

                var otherTarget = this.name === targetColumn ? otherTargetColumn : targetColumn;
                var row = $this.closest('.k-grid-edit-row');

                var model = gridConfig.dataSource.getByUid(row.data('uid'));

                model.set(otherTarget, null);
                $('[name="' + otherTarget + '"]').data('kendoNumericTextBox').value(null);
            });  
        },
        initReviewGrid: function(grid, gridConfig, model, listType, ignoredValueOverrideColumns){
            var prkeField = 'Prke'
                , banP5PrkeField = 'BanP5Prke'
                , banP5PromField = 'BanP5Prom'
                , statusField = 'Status'
                , prkeColumn = _.find(gridConfig.columns, {field: prkeField});

            grid = $(grid);
            
            gridConfig.excel = {
                forceProxy: true, 
                proxyURL: '/DPN/Offers/ExportRequestRows/' + model.Id + '?listType=' + listType
            };
            
            if (!model.EnableRowEditing){
                MDB.DPN.Offers.Requests.removeEditOptions(gridConfig);
            } else{
                grid.closest('.grid-container')
                    .find('.set-row-value')
                    .on('click', function () {
                        var $this = $(this);
                        
                        var field = $this.data('field');
                        var value = $this.data('value');
                        
                        _.forEach(grid.data('kendoGrid').dataSource.data(), function(gridModel){
                            gridModel[field] = value;
                            gridModel.dirty = true;
                        });
                        
                        syncAndReloadGrid(grid);
                    });
                
                gridConfig.editable = 'inline';
                gridConfig.columns.unshift({
                    command: [
                        {
                            name: 'edit',
                            text: '',
                            iconClass: 'grid-icon fa fa-lg fa-pencil'
                        }
                    ],
                    title: MDB.loadResourceString('OfferRequestGroup_CommandColumn_Title'),
                    width: 85
                });

                MDB.DPN.Offers.Requests.addGridValueOverrideSelector(
                    grid, 
                    gridConfig,
                    _.union(ignoredValueOverrideColumns, ['ProductId', 'ProductName', 'BanP5Prke','BanP5Prom','Status','Prke'])
                );
                
                var banP5PrkeColumn = _.find(gridConfig.columns, {field: banP5PrkeField});
                var banP5PromColumn = _.find(gridConfig.columns, {field: banP5PromField});
                var statusColumn = _.find(gridConfig.columns, {field: statusField});
                
                statusColumn.template = function (model) {
                    return sprintf(
                        '<input type="checkbox" value="1" class="change-status pull-left" %s/>' + 
                        '<input type="checkbox" value="2" class="change-status pull-right" %s/>', 
                        model.Status === 1 ? 'checked="checked"' : '', 
                        model.Status === 2 ? 'checked="checked"' : ''
                    );
                };
                
                statusColumn.editor = function (container, opts) {
                    if(opts.model.isNew()){
                        return;
                    }
                    
                    $(container).append(statusColumn.template(opts.model));
                };

                prkeColumn.editor = function (container, opts) {
                    if(opts.model.isNew()){
                        return;
                    }
                    
                    prkeDropdownEditor(container,  opts);
                    
                    container.append('<a class="k-button k-button-icontext new-prke" href="#"><span class="grid-icon fa fa-lg fa-file"/></a>');
                };

                banP5PromColumn.editor = function (container, opts) {
                    container.removeClass('k-edit-cell');
                    container.text(opts.model[banP5PromField]);
                };
                
                banP5PrkeColumn.template = function (model) {
                    if (!model[prkeField]) {
                        return '';
                    }
                    
                    if (model[banP5PrkeField]) {
                        return model[banP5PrkeField];
                    }
                    
                    return '<a class="k-button k-button-icontext new-ban-p5-prke" href="#"><span class="grid-icon fa fa-lg fa-file"/></a>';
                };
                
                banP5PrkeColumn.editor = function (container, opts) {
                    if (!opts.model.Prke) {
                        return;
                    }
                    
                    if (opts.model[banP5PrkeField]){
                        container.removeClass('k-edit-cell');
                        container.text(opts.model[banP5PrkeField]);
                        
                        return;
                    }
                    
                    container.append('<a class="k-button k-button-icontext new-ban-p5-prke" href="#"><span class="grid-icon fa fa-lg fa-file"/></a>');
                };
                

                grid.on('click', '.change-status', function (e) {
                    var status = parseInt(this.value);
                    
                    if (this.checked){
                        //Uncheck other box
                        $(this).siblings(':checked').removeAttr('checked');
                    } else{
                        //Reset status to new
                        status = 0;
                    }

                    updateGridModel(this, e, function(model) {
                        model[statusField] = status;
                    });
                });
                
                grid.on('click', '.row-checkbox', function () {
                    var model = findModelForEvent(this);
                    model.set($(this).data('field'), this.checked);
                });

                grid.on('click', '.new-prke', function () {
                    var model = findModelForEvent(this);
                    
                    //Create a deep copy to remove and prevent prefilling the Id column
                    var modelCopy = $.extend(true, {}, model);
                    delete modelCopy.Id;

                    MDB.DPN.Offers.displayNewOfferPrompt(function (offer) {
                        model.set(prkeField, offer.Id);
                    }, modelCopy);
                });
                
                grid.on('click', '.new-ban-p5-prke', function () {
                    var model = findModelForEvent(this);

                    var p5Titles = MDB.DPN.Offers.getTitles('p5');
                    var allTitltes = dropdownConfigs['TitleIds'].dataSource.data;
                    var defaultTitle = _.find(allTitltes,  {Text: model.ProductName});
                    
                    if (!defaultTitle){
                        defaultTitle = _.find(allTitltes, function (item) {
                            return p5Titles.indexOf(item.Text) !== -1;
                        })
                    }
                    
                    var availableTitles = {};
                    allTitltes.forEach(function (item) {
                        availableTitles[item.Text] = item.Value;
                    });
                    
                    
                    function rowAdded(row) {
                        var predicate = function () {
                            return model.ProductName === row.Title;
                        };
                        
                        if(model.ProductName === 'WEG'){
                            predicate = function () {
                                return p5Titles.indexOf(row.Title) !== -1;
                            }
                        }
                        
                        if (_.find(allTitltes, predicate)){
                            model.set(banP5PromField, row.BAN_P5_PROM_ID);
                            model.set(banP5PrkeField, row.BAN_P5_PRKE_ID);
                            MDB.killOpenModals();
                        }
                    }
                    
                    var popup = MDB.DPN.Offers.displayOfferPerProductSelectionPrompt({
                        defaultTitle: defaultTitle,
                        availableTitles: availableTitles,
                        id: model[prkeField],
                        onUpdateSuccess: rowAdded,
                        onCreateSuccess: rowAdded
                    });
                    
                    $(popup);
                });


                grid.on('click', '.new-p5-prke', function (e) {
                    var element = this;
                    var model = findModelForEvent(element);

                    var fields = _.keys(gridConfig.dataSource.options.schema.model.fields);
                    var data = {};
                    
                    _.keys(model).forEach(function(key){
                        if(fields.indexOf(key) === -1) {
                            return;
                        }
                        var value = model[key];

                        if (!!value && _.isArrayLikeObject(value)) {
                            value = _.filter(value, _.isString);
                        }

                        data[key] = value;
                    });

                    $.ajax({
                        url: '/api/DPN/Offers/P5RequestRow',
                        method: 'POST',
                        data: data,
                        success: function (data) {
                            updateGridModel(element, e, function(model) {
                                model[banP5PrkeField] = data[banP5PrkeField];
                                model.PrkeValues = data.PrkeValues;
                            });
                        }
                    });
                });

                if (!gridConfig.toolbar) {
                    gridConfig.toolbar = [];
                }
                if (gridConfig.toolbar.indexOf('create') === -1) {
                    gridConfig.toolbar.push('create');
                }
                
                
                var prkeDropdownEditor = function(container, opts){
                    return MDB.KendoConfigBuilder.gridDropdownEditor(container,  opts.field, null,  {
                        dataValueField: 'Id',
                        dataTextField: 'Description',
                        optionLabel: 'Selecteer PRKE',
                        dataSource: {
                            transport: {
                                read: function (crudOpts) {
                                    var url = crudServiceBaseUrl + sprintf('/RequestRowPrkes?rowId=%s&groupingId=%s', opts.model.Id, opts.model.GroupingId);
                                    MDB.KendoConfigBuilder.dataSourceTransportFunction(url, 'GET', crudOpts);
                                }
                            }
                        },
                        change: function (e) {
                            //Using the set function of the model also triggers a save action
                            //which in turn closes the editor
                            opts.model[opts.field] = e.sender.value();
                            opts.model.PrkeName = e.sender.text();
                            
                            opts.model.dirty = true;
                            
                            //opts.model.set(opts.field, e.sender.value());
                        },
                        dataBound: function (e) {
                            e.sender.wrapper.css({width: '225px'});
                        }
                    }, opts);
                };

                var findModelForEvent = function(target) {
                    var $target = $(target);

                    var row = $target.closest('tr[data-uid]');

                    var ds = grid.data('kendoGrid').dataSource;
                    return ds.getByUid(row.data('uid'));
                };

                var updateGridModel = function(element, event, processModel) {
                    var model = findModelForEvent(element);
                    var isEditMode = $(event.target).closest('tbody').find('.k-grid-edit-row').length;

                    processModel(model);
                    model.dirty = true;

                    //Force sync via set if grid is not editable to still save the applied changes
                    if (!isEditMode) {
                        grid.data('kendoGrid').options.dataSource.sync();
                    }
                };
            }
            
            return grid.kendoGrid(gridConfig);
        },
        SetPrkeValues: function(url) {
            var elements = $('.k-grid');

            MDB.alert(undefined, MDB.loadResourceString('OfferRequest_loadingResults_Text'), {
                'show.bs.modal': function () {
                    $(this).find('.modal-body').append($('<div />', { 'class': 'loading' }));
                }
            });


            $.ajax({
                type: "GET",
                url: url,
                contentType: "application/json",
                dataType: "json",
                success: function (data) {
                    if (data.success) {
                        _.forEach(elements, function (grid) {
                            MDB.KendoConfigBuilder.getKendoWidget($(grid)).dataSource.read();
                        });
                        MDB.killOpenModals();
                    }
                },
                error: function () {
                    alert('Something went wrong.');
                }
            });
        }
    });
    
})(jQuery);